import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from './styles';
import { TicketHistoryHandler } from '../TicketHistoryHandler';

const TicketDetails = () => (
  <TicketHistoryHandler />
);

export default withStyles(styles, { withTheme: true })(TicketDetails);
